























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SFTPChannelDetails } from '@/types';
import { Getter } from 'vuex-class';

@Component
export default class SFTPIntegration extends Vue {
  @Prop() private integrationDetails!: SFTPChannelDetails;
  private authType: string = 'privateKey';
  @Getter private hasPermission!: any;
  private showSecret: boolean = false; // TODO: Temporary, but needs to be addressed correctly
  private readonly rules: any = {
    required: (value: string) => !!value || 'This field is required.',
  };

  private handleErrorChange(value: boolean) {
    this.$emit('validate', !value);
  }
  @Watch( 'authType' )
  private onAuthTypeChange() {
    if ( this.authType === 'privateKey' ) {
      this.integrationDetails.password = '';
    } else if ( this.authType === 'password' ) {
      this.integrationDetails.privateKey = '';
    }
  }

  private beforeMount() {
    this.integrationDetails.port = this.integrationDetails.port || 22;
    if (this.integrationDetails && this.integrationDetails.password) {
      this.authType = 'password';
    }
  }
}
